// extracted by mini-css-extract-plugin
export default {"writePage":"writePage--rl4kg","content":"content--rYg2K","content_left":"content_left--v5fvl","content_right":"content_right--vGxYX","spinLoading":"spinLoading--AP_Gj"};